export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtVybavavoz';
export const NAME = 'VybavaVozidla';
